<template>
  <div class="regular-table">
    <div class="regular-table-body">
      <div class="regular-table-scroll">
        <Table border
               column-width-drag
               :row-class-name="rowClassName" :columns="columns" :data="rows" :show-header="showHeader"
               :width="width"
               :height="height"
               @on-sort-change="setSortChange"
               @on-selection-change="handleSelectChange"
        >
          <template v-for="(oper) in operKey" slot-scope="{ row, index }" :slot="oper.name">
            <template v-if="Array.isArray(row[oper.name])">
              <template v-for="(rowItem, itemIndex) in row[oper.name]">
                <span v-if="oper.action.addr" :key="oper.name+itemIndex" class="link-span" @click="clickOperBtn(rowItem, oper)">{{rowItem[oper.action.label]}}</span>
                <span v-else :key="oper.name+itemIndex" class="unit-span">{{rowItem[oper.action.label]}}</span>
              </template>
            </template>
            <template v-else>
              {{oper.action.label ? (oper.map ? oper.map[row[oper.name]]:row[oper.name]) : ''}}
              <template v-if="!permission.flag || (permission.flag && permission.buttons.includes(oper.name))">
                <Divider :key="oper.name+'-divider'" v-if="!!oper.action.label" type="vertical"></Divider>
                <span :key="oper.name" class="link-span" @click="clickOperBtn(row, oper)">{{oper.action.label ? oper.action.label:(oper.map ? oper.map[row[oper.name]]:row[oper.name])}}</span>
              </template>
            </template>
          </template>
          <template v-for="icon in iconList" slot-scope="{ row }" :slot="icon.name">
            <Icon :key="icon.name" :type="row[icon.name]" style="font-size: 18px"></Icon>
          </template>
          <template v-for="checkboxItem in checkboxList" slot-scope="{ row }" :slot="checkboxItem.name">
            <Checkbox :key="checkboxItem.name" :value="row[checkboxItem.name]==='1'" :disabled="true" :class="{light: row[checkboxItem.name]==='1'}"></Checkbox>
          </template>
          <template v-for="option in mapList" slot-scope="{ row }" :slot="option.name">
            <template v-if="typeof option.map[row[option.name]] === 'object'">
              <Badge :key="option.name+'_badge'" v-if="option.map[row[option.name]].append.shape === 'point'" :status="option.map[row[option.name]].append.type"></Badge>
              {{option.map[row[option.name]].value || row[option.name]}}
            </template>
            <template v-else>{{option.map[row[option.name]] || row[option.name]}}</template>
          </template>
          <!-- <template v-for="option in mapList" slot-scope="{ row }" :slot="option.name">
            {{option.map[row[option.name]]}}
          </template> -->
          <template v-for="action in operList" slot-scope="{ row, index }" :slot="action.name">
            <Button v-for="(oper, index) in action.actionList"
                    v-if="evil(oper.filter, row) && (!permission.flag || (permission.flag && permission.buttons.includes(oper.name)))"
                    size="small"
                    :key="index"
                    :type="oper.kind"
                    @click="clickOperBtn(row, oper)">{{oper.label}}</Button>
          </template>
        </Table>
      </div>
    </div>
    <Page v-if="pager.show"
          :total="Number(pager.total)"
          :page-size="Number(pager.size)"
          :current="Number(pager.curr)"
          :page-size-opts="[10, 20, 30, 40, 500]"
          size="small"
          show-total
          show-elevator
          show-sizer
          @on-change="setPageChange"
          @on-page-size-change="setPageSizeChange">
    </Page>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import ExpandTable from './regularTable'

export default {
  name: 'regularTable',
  components: {ExpandTable},
  props: {
    permission: {
      type: Object,
      default: () => {
        return {
          flag: false,
          buttons: []
        }
      }
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    headConfig: {
      type: Array
    },
    legent: {
      type: Array
    },
    minWidth: {
      type: Number
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    checkboxFilter: {
      type: String,
      default: ''
    },
    rows: {
      type: Array
    },
    pager: {
      type: Object,
      default: () => {
        return {}
      }
    },
    loading: Boolean
  },
  data () {
    return {
      key: '', // ID name
      columns: [], // 列头
      operKey: [],
      operList: [], // 操作列表
      iconList: [], // 小图标列表
      checkboxList: [], // checkbox 列表
      mapList: [], // 映射列表
      height: 300, // 表格高度
      width: 500, // 表格宽度
      fixedFlag: false // 表格中是否有固定列
    }
  },
  created () {
    const _self = this;
    // 处理headConfig数据
    _self.handleHeadConfig();

    // 判断是否需要判断checkbox的可用性
    if (_self.checkboxFilter) {
      for (let item of _self.rows) {
        let itemFilter = _self.checkboxFilter;
        for (let key of Object.keys(item)) {
          itemFilter = itemFilter.replace('{' + key + '}', item[key]);
        }
        item._disabled = _self.evil('!(' + itemFilter + ')');
      }
    }
  },
  mounted () {
    const _self = this;
    // 通过计算height可以控制表格滚动条显示在一个页面中
    // 根据分页是否显示控制高度
    _self.height = _self.$el.clientHeight - 42;
    _self.width = _self.$parent.$el.clientWidth - 20;
    if (!_self.fixedFlag && _self.minWidth > _self.width) _self.width = _self.minWidth;
  },
  watch: {
    rows: {
      handler (val) {
        // 判断是否需要判断checkbox的可用性
        const _self = this;
        if (_self.checkboxFilter) {
          for (let item of _self.rows) {
            let itemFilter = _self.checkboxFilter;
            for (let key of Object.keys(item)) {
              itemFilter = itemFilter.replace('{' + key + '}', item[key]);
            }
            item._disabled = _self.evil('!(' + itemFilter + ')');
          }
        }
      },
      deep: true
    },
    headConfig: {
      handler (val) {
        // 重新绘制表格
        this.handleHeadConfig();
      },
      deep: true
    }
  },
  methods: {
    handleHeadConfig () {
      const _self = this;
      // 数据初始化
      _self.columns = [];
      _self.operKey = [];
      _self.operList = [];
      _self.iconList = [];
      _self.checkboxList = [];
      _self.mapList = [];

      if (_self.showCheckbox) {
        _self.columns.push({
          type: 'selection',
          width: 60,
          align: 'center'
        });
      }
      for (let head of _self.headConfig) {
        let column = {
          title: head.label,
          sortable: head.sort,
          width: head.width || 'auto',
          ellipsis: true,
          tooltip: true
        };
        if (head.key) {
          _self.key = head.name;
          continue;
          // id字段不展示，如果需要展示，再做修改
        }
        // 固定列
        if (head.hasOwnProperty('fixed')) {
          column.fixed = head.fixed;
          _self.fixedFlag = true;
        }

        if (head.type === 'expand') {
          column.type = 'expand';
          column.render = function (h, params) {
            return h('ExpandTable', {
              props: {
                headConfig: column.headConfig,
                rows: params.row.list
              }
            })
          }
        } else if (head.action) {
          // 字段内容操作事件
          _self.operKey.push(head);
          column.slot = head.name;
        } else if (head.actionList && Array.isArray(head.actionList)) {
          // 操作列表处理
          _self.operList.push(head);
          column.slot = head.name;
          column.align = 'center';
        } else if (head.type === 'icon') {
          // 图标转换
          _self.iconList.push(head);
          column.slot = head.name;
        } else if (head.type === 'checkbox') {
          // checkbox转换
          _self.checkboxList.push(head);
          column.width = 80;
          column.slot = head.name;
        } else if (head.hasOwnProperty('map')) {
          // 映射字段翻译
          _self.mapList.push(head);
          column.slot = head.name;
        } else {
          column.key = head.name;
        }
        _self.columns.push(column);
      }
    },
    clickOperBtn (row, oper) {
      oper = JSON.parse(JSON.stringify(oper));
      if (!oper.action) {
        oper.action = oper;
      }
      this.$emit('clickTableBtn', oper, row);
    },
    setSortChange (data) {
      console.log('排序', data);
    },
    setPageChange (page) {
      this.$emit('changePage', page, this.pager.size);
    },
    setPageSizeChange (size) {
      this.$emit('changePage', 1, size);
    },
    rowClassName (row, index) {
      const _self = this;
      if (_self.legent.length > 0) {
        for (let legent of _self.legent) {
          if (_self.evil(legent.expression, row)) {
            return legent.css;
          }
        }
      }
      return '';
    },
    handleSelectChange (selection, row) {
      let selectionIds = [];
      selection.every(item => selectionIds.push(item[this.key]));
      // console.log(selectionIds);
      this.$emit('onSelect', selectionIds);
    },
    // 模拟eval
    evil (fn, row) {
      if (fn) {
        let Fn = Function; // 一个变量指向Function，防止有些前端编译工具报错
        return new Fn('let row = ' + JSON.stringify(row) + '; return ' + fn)();
      } else {
        return true;
      }
    }
  }
}
</script>

<style lang="less">
  .regular-table {
    overflow: hidden;
    display: flex;
    flex-flow: column;
    height: 100%;
    .regular-table-body {
      overflow: hidden;
      flex: 1;
      .regular-table-scroll {
        width: 100%;
        height: 100%;
        overflow: auto;
      }
      .kh-table-fixed-right, .kh-table-fixed-left {
        background-color: @body-background;
      }
      .kh-table-fixed-body {
        td, th {
          height: 36px;
          .kh-btn {
            background-color: transparent;
            border-color: transparent;
            &:focus {
              border-color: transparent;
              box-shadow: none;
            }
            &.kh-btn-primary {
              color: @base-color;
            }
            &.kh-btn-error {
              color: @error-color;
            }
            &.kh-btn-warning {
              color: @warning-color;
            }
          }
        }
      }
    }
    .kh-table-body {
      .kh-table-row {
        td {
          border-left: 1px solid #E8EAEC;
          border-right: 1px solid #E8EAEC;
          height: 35px;
          line-height: 35px;
          .kh-table-cell {
            height: 35px;
            .kh-checkbox-wrapper.light {
              .kh-checkbox-inner {
                border-color: @base-color;
                background-color: @base-color;
              }
            }
          }
          .link-span {
            cursor: pointer;
            text-decoration: underline;
            margin-right: 10px;
            &:last-child {
              margin-right: 0;
            }
          }
          .unit-span {
            cursor: pointer;
            margin-right: 10px;
            &:last-child {
              margin-right: 0;
            }
          }
          .kh-btn {
            background-color: transparent;
            border-color: transparent;
            &:focus {
              border-color: transparent;
              box-shadow: none;
            }
            &.kh-btn-primary {
              color: @base-color;
            }
            &.kh-btn-error {
              color: @error-color;
            }
            &.kh-btn-warning {
              color: @warning-color;
            }
          }
        }
      }
    }
    .kh-page {
      padding: 10px 2px 5px;
      text-align: right;
    }
    .kh-table-expanded-cell {
      padding: 0;
      /*.kh-table-wrapper {
        border: 0 none;
        .kh-table-border{
          &::before {
            height: 0;
          }
          &::after {
            width: 0;
          }
        }
        .kh-table-border td, .kh-table-border th {
          border: 0 none;
        }
      }*/
    }
  }
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/table/regularTable.vue